export default "__VITE_ASSET__DRYgAyNK__"